const ham = document.getElementById('hamburger');
const nav = document.getElementsByTagName('header')[0];
const cartBtn = document.getElementsByClassName('cart-btn');
const cartClose = document.getElementById('close-cart');
const opacity = document.getElementById('opacity');
const loginBtn = document.getElementsByClassName('login-btn--login');
const loginModal = document.getElementById('login');
const loginModalClose = document.getElementById('close-login');
const searchBtn = document.querySelector('.search-btn svg');
const searchForm = document.getElementById('search-form');
const worldBtn = document.querySelector('.world-btn svg');
const countryModal = document.getElementById('countryModal');
const countryModalClose = document.getElementById('close-countryModal');


const openCart = () =>{
  document.getElementById('cart-ajax').classList.remove('close');
  document.getElementById('opacity').classList.add('active');
  document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
  getCart();
}
const closeCart = () =>{
  document.getElementById('cart-ajax').classList.add('close');
  document.getElementById('opacity').classList.remove('active');
  document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
}
const toggleMenu = () =>{
  nav.classList.toggle('open');
  if(nav.classList.contains('open')){
    document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
  }else{
    document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
  }
}

searchBtn.addEventListener('click', () =>{
  searchForm.classList.toggle('active');
  searchForm.querySelector('input[type="search"]').focus();
})

opacity.addEventListener('click', () =>{
  closeCart();
  opacity.classList.remove('active');
  loginModal.classList.add('hidden');
  countryModal.classList.add('hidden');
})

ham.addEventListener('click',toggleMenu);
for(c of cartBtn){
  c.addEventListener('click',openCart);
}
cartClose.addEventListener('click',closeCart);

for(let l of loginBtn){
  l.addEventListener('click', () =>{
    opacity.classList.add('active');
    loginModal.classList.remove('hidden');
    document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
  })
}

loginModalClose.addEventListener('click', () =>{
  opacity.classList.remove('active');
  loginModal.classList.add('hidden');
  document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
})

worldBtn.addEventListener('click', () =>{
  opacity.classList.add('active');
  countryModal.classList.remove('hidden');
  document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
})
countryModalClose.addEventListener('click', () =>{
  opacity.classList.remove('active');
  countryModal.classList.add('hidden');
  document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
})



// ---------------------------------------------------------------------------
// Header submenu toggle
// ---------------------------------------------------------------------------

$(document).ready(function() {
  const submenus = $('.has_submenu span');
  submenus.on( "click", function() {
      $(this).next().fadeToggle('fast');
      $(this).toggleClass('open');
    }
  );
});